import { gql } from 'apollo-angular';

export var add_committee_link = gql`
  mutation addCommitteeLink($input: CommitteeLinkInput!) {
    addCommitteeLink(input: $input) {
      id
      name
      url
      milestone_id
      is_package
      is_default_link
    }
  }
`;
